import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucidePause = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <rect width={5} height={18} x={14} y={3} rx={1} />
      <rect width={5} height={18} x={5} y={3} rx={1} />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucidePause);
const Memo = memo(ForwardRef);
export default Memo;
